import { render, staticRenderFns } from "./liveUnderway.vue?vue&type=template&id=8cb7c42c&scoped=true"
import script from "./liveUnderway.vue?vue&type=script&lang=js"
export * from "./liveUnderway.vue?vue&type=script&lang=js"
import style0 from "./liveUnderway.vue?vue&type=style&index=0&id=8cb7c42c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cb7c42c",
  null
  
)

export default component.exports